<template>
  <div class="fts-list">
    <draggable v-model="formData[item.fieldName]" v-bind="dragOptions" handle=".handle">
      <div class="list-form list-content" v-for="(data, index) in formData[item.fieldName]" :key="data.id">
        <!-- header -->
        <div class="list-form-header" @click="toggle(data)" :class="{'expanded': !data.hide}">
          <!-- ctrl -->
          <div class="list-form-header-ctrl stopPropagation" v-if="!view">
            <!-- handle -->
            <font-awesome-icon class="handle" :icon="['fas', 'grip-vertical']" fixed-width />
            <!-- add -->
            <fts-btn text icon sm @click="add(index + 1)">
              <font-awesome-icon :icon="['fas', 'plus']" />
            </fts-btn>
            <!-- remove -->
            <fts-btn text icon sm @click="remove(data)">
              <font-awesome-icon :icon="['fas', 'trash']" />
            </fts-btn>
          </div>
          <!-- title -->
          <div class="list-form-header-title">{{title(data, index)}}</div>
          <!-- toggle -->
          <div class="list-form-header-toggle">
            <font-awesome-icon :icon="['fas', 'chevron-down']" />
          </div>
        </div>
        <!-- form -->
        <fts-transition-expand>
          <fts-form 
            :formData="data" 
            :form="form"
            :view="view" 
            :validator="columnValidator(index)"
            v-if="!data.hide" />
        </fts-transition-expand>
      </div>
    </draggable>
    <!-- add -->
    <div class="list-form-action" @click="add(formData[item.fieldName]? formData[item.fieldName].length : 0)" v-if="!view">
      <font-awesome-icon :icon="['fas', 'plus']" fixed-width /> New
    </div>
  </div>
</template>

<script>
import commons from "../commons/commons";
import draggable from "vuedraggable";

import FTSTransitionExpand from "./FTSTransitionExpand";
import FTSBtn from "./FTSBtn";

export default {
  components: {
    draggable,
    "fts-transition-expand": FTSTransitionExpand,
    "fts-btn": FTSBtn
  },
  props: {
    item: Object,
    formData: Object,
    view: Boolean,
    validator: Object,
  },
  data: () => ({
    dragOptions: commons.dragOptions,
  }),
  methods: {
    toggle(data) {
      if (commons.elementStopPropagation()) return;

      if (data.hide)
        this.$delete(data, 'hide')
      else
        this.$set(data, 'hide', true)
    },
    add(index) {
      let newRow = {
        id: commons.newUUID()
      };

      this.item.fields.forEach(x => {
        if (x && x.fieldName.indexOf(".") === -1) {
          this.$set(newRow, x.fieldName, null);
        }
      });

      if (this.formData[this.item.fieldName] == null) {
        this.$set(this.formData, this.item.fieldName, []);
      }

      this.formData[this.item.fieldName].splice(index, 0, newRow);
    },
    remove(data) {
      let listData = this.formData[this.item.fieldName];
      listData.splice(listData.indexOf(data), 1);
    },
    title(data, index) {
      if (this.item.displayField) {
        try {
          const field = this.item.fields.find(x => x.displayName === this.item.displayField)
          const value = data[field.fieldName]
          if (value)
            return value
          else
            throw 'error'
        } catch(err) {
          return this.item.displayField
        }
      } else {
        return `${this.item.displayName} (${index + 1})`
      }
    },
    columnValidator(index) {
      try {
        const validations =  Object.values(this.validator.$each.$iter)
        return validations[index]
      } catch(err) {}
    }
  },
  computed: {
    form() {
      commons.expandWorkDesign(this.item.fields, this.item.design)
      return this.item.design
    }
  },
  beforeCreate: function () {
		this.$options.components.FtsForm = require('./FTSForm').default
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-list {
  .list-form {
    margin-bottom: .75rem;
    border: 1px solid var(--fts-gray-3);
    .list-form-header {
      display: flex;
      align-items: center;
      padding: 0 1rem;
      background: var(--fts-gray-1);
      &.expanded {
        .list-form-header-toggle {
          > svg {
            transform: rotate(-90deg);
          }
        }
      }
      .list-form-header-ctrl {
        display: flex;
        align-items: center;
        margin-right: .375rem;
        > svg {
          &.handle {
            margin-right: .175rem;
            color: var(--fts-gray-5);
            font-size: .75rem;
            cursor: grab;
          }
        }
      }
      .list-form-header-title {
        flex: 1;
        padding: .75rem 0;
        font-weight: bold;
        font-size: .875rem;
        line-height: 1.5;
        cursor: pointer;
      }
      .list-form-header-toggle {
        cursor: pointer;
        > svg {
          transition: transform .3s;
          font-size: .75rem;
        }
      }
    }
    > .fts-form-container {
      padding-top: 1rem;
    }
  }
  .list-form-action {
    padding: .575rem 1rem;   
    background: var(--fts-gray-1);   
    font-size: .75rem;
    color: var(--fts-gray-5); 
    line-height: 1.5;
    &:hover {
      cursor: pointer;
      color: $primaryColor;
    }
  }
}
</style>